/* src/app/components/case/uploads/dat-metadata-mapping/dat-metadata-mapping.component.scss */
tr:hover {
  background: #f1f1f1;
  transition: 250ms ease-out;
}
.mat-toolbar .fa-exclamation-circle {
  color: inherit;
}
.field-icon {
  margin-right: 8px;
  vertical-align: middle;
}
.field-title {
  vertical-align: middle;
}
.string-type {
  color: #1976d2;
}
.date-type {
  color: #388e3c;
}
.bool-type {
  color: orange;
}
.special-type {
  color: #7b1fa2;
}
.unknown-type {
  color: lightslategray;
}
:host-context(.dark-theme) tr:hover {
  background: rgba(255, 255, 255, 0.0784313725);
}
:host-context(.dark-theme) .mat-card:not([class*=mat-elevation-z]) {
  background-color: #2c2c2c;
}
td.mat-column-title {
  color: #3f51b7;
}
/*# sourceMappingURL=dat-metadata-mapping.component.css.map */
